import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { COMMON_API } from "../../commonAPI";

const LoanCriteriaList = () => {
  const [loans, setLoans] = useState([]);
  const [selectedLoanId, setSelectedLoanId] = useState("");
  const [criteria, setCriteria] = useState([]);
  const token = sessionStorage.getItem("authToken");

  const fetchLoans = async () => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/allLoans`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLoans(res.data.loan || []);
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  };

  const fetchCriteria = async (loanId) => {
    try {
      const res = await axios.get(`${COMMON_API}/loan/getLoanCriteriaById/${loanId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      setCriteria(res.data.criteria || []);
    } catch (error) {
      console.error("Error fetching criteria:", error);
    }
  };

  useEffect(() => {
    fetchLoans();
  }, []);

  useEffect(() => {
    if (selectedLoanId) fetchCriteria(selectedLoanId);
  }, [selectedLoanId]);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Loan Criteria</h2>

        <div className="mb-6">
          <label className="block text-gray-600 font-medium mb-1">Select Loan</label>
          <select
            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            value={selectedLoanId}
            onChange={(e) => setSelectedLoanId(e.target.value)}
          >
            <option value="">-- Select Loan --</option>
            {loans.map((loan) => (
              <option key={loan.id} value={loan.id}>
                {loan.name}
              </option>
            ))}
          </select>
        </div>

        {selectedLoanId && (
          <>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-gray-700">Criteria List</h3>
              <Link
                to="/add-loan-criteria"
                state={{ loan_id: selectedLoanId }}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                + Add Criteria
              </Link>
            </div>

            <div className="space-y-3">
              {criteria.map((c) => (
                <div
                  key={c.id}
                  className="flex justify-between items-center p-4 border rounded-lg shadow-sm bg-gray-50 hover:bg-gray-100 transition"
                >
                  <span className="text-gray-700">{c.description}</span>
                  <div className="flex gap-2">
                    <Link
                      to={`/edit-loan-criteria/${c.id}`}
                      className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition"
                    >
                      Edit
                    </Link>
                    <button
                      className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition"
                      onClick={async () => {
                        await axios.delete(`${COMMON_API}/loan/deleteLoanCriteria/${c.id}`, {
                          headers: { Authorization: `Bearer ${token}` },
                        });
                        fetchCriteria(selectedLoanId);
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
              {criteria.length === 0 && (
                <p className="text-gray-500 text-center">No criteria found for this loan.</p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LoanCriteriaList;
